import { MutableRefObject, useEffect, useRef, RefCallback } from 'react';

export const useForwardedRef = <T>(inputRef: RefCallback<T | null> | MutableRefObject<T | null> | null | undefined) => {
   const localRef = useRef<T | null>(null);

   useEffect(() => {
      if (!inputRef) return;

      if (typeof inputRef === 'function') {
         inputRef(localRef.current);
      } else {
         inputRef.current = localRef.current;
      }
   }, [inputRef]);

   return localRef;
};
